import { createAsyncThunk } from "@reduxjs/toolkit";
import { DocumentService } from "../../../../api";

export const getDocumentPhysicalDetails = createAsyncThunk(
	"notesSelectedDocument/getDocumentPhysicalDetails",
	({ docId, token }) => DocumentService.getDocumentPhysicalDetails({ docId }, token)
);
